// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__DOZ0J","TopDiv":"style_TopDiv__1Sb8U","Desc":"style_Desc__1JiyG"};